import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ProductSection extends Vue {

  @Prop() title!: string;
  @Prop({default: 'auto'}) titleHeight!: string;
}
